// Utils
import { getColorCSSVar, getCSSVar } from './getCSSVarUtil';
import { getAttributeData } from './brandingUtil';

// Constants
import BRANDING from '../constants/brandingConst';
import BRANDING_CSS_VARS from '../constants/brandingCSSVarsConst';
import BRANDING_KEYS from '../constants/brandingKeysConst';

const getTypographyTheme = (attributes) => {
    const { GLOBAL_BODY_FONT_FAMILY, GLOBAL_HEADING_FONT_FAMILY } = BRANDING;

    return {
        ...getCSSVar(
            attributes,
            GLOBAL_HEADING_FONT_FAMILY,
            BRANDING_CSS_VARS[GLOBAL_HEADING_FONT_FAMILY],
        ),
        ...getCSSVar(
            attributes,
            GLOBAL_BODY_FONT_FAMILY,
            BRANDING_CSS_VARS[GLOBAL_BODY_FONT_FAMILY],
        ),
    };
};

const getLinkTheme = (attributes) => {
    const { GLOBAL_LINK_COLOR } = BRANDING;

    return {
        ...getColorCSSVar(
            attributes,
            GLOBAL_LINK_COLOR,
            BRANDING_CSS_VARS[GLOBAL_LINK_COLOR],
        ),
    };
};

const getColorsTheme = (attributes) => {
    const {
        GLOBAL_FONT_COLOR,
        GLOBAL_SUCCESS_COLOR,
        GLOBAL_WARNING_COLOR,
        GLOBAL_ERROR_COLOR,
        GLOBAL_INFO_COLOR,
        GLOBAL_PRIMARY_COLOR,
        GLOBAL_SECONDARY_COLOR,
        GLOBAL_TERTIARY_COLOR,
        BODY_TEXT_COLOR,
    } = BRANDING;

    let fontColorConst = GLOBAL_FONT_COLOR;
    const { value: bodyTextColor } = getAttributeData(
        attributes,
        BRANDING_KEYS[BODY_TEXT_COLOR],
    );

    if (bodyTextColor) {
        fontColorConst = BODY_TEXT_COLOR;
    }

    return {
        ...getColorCSSVar(
            attributes,
            fontColorConst,
            BRANDING_CSS_VARS[GLOBAL_FONT_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_SUCCESS_COLOR,
            BRANDING_CSS_VARS[GLOBAL_SUCCESS_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_WARNING_COLOR,
            BRANDING_CSS_VARS[GLOBAL_WARNING_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_ERROR_COLOR,
            BRANDING_CSS_VARS[GLOBAL_ERROR_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_INFO_COLOR,
            BRANDING_CSS_VARS[GLOBAL_INFO_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_PRIMARY_COLOR,
            BRANDING_CSS_VARS[GLOBAL_PRIMARY_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_SECONDARY_COLOR,
            BRANDING_CSS_VARS[GLOBAL_SECONDARY_COLOR],
        ),
        ...getColorCSSVar(
            attributes,
            GLOBAL_TERTIARY_COLOR,
            BRANDING_CSS_VARS[GLOBAL_TERTIARY_COLOR],
        ),
    };
};

const globalThemeUtil = (attributes) => {
    return {
        ...getTypographyTheme(attributes),
        ...getLinkTheme(attributes),
        ...getColorsTheme(attributes),
    };
};

export default globalThemeUtil;
